import { LoginForm, RegisterForm } from '@/features/auth'

export function LoginPage() {
  return <LoginForm />
}

export function RegisterPage() {
  return <RegisterForm />
}
